import { useTranslation } from 'react-i18next'

import styles from './style.module.scss'

/**
 * Lehrkräfte und Verwaltung sehen den Kurs, wie ihn die Schüler:innen sehen —
 * aber nur zur Ansicht. Ohne diesen Hinweis wunderte man sich, warum nach dem
 * dritten Video kein Haken erscheint.
 */
export default function PreviewBanner() {
	const { t } = useTranslation()

	return (
		<div className={styles.preview} role="note">
			{t('Preview — progress is not saved and there is no certificate.')}
		</div>
	)
}
